import type { SVGProps } from 'react';
const SvgIncrease = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M14.779 7.17V4.453H12.06M14 5l-3.126 3.367c-.178.191-.4.327-.644.393-.244.067-.5.06-.741-.017L5.952 7.725a1.3 1.3 0 0 0-.72 0 1.4 1.4 0 0 0-.624.388L1 12"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgIncrease;
